import React from "react";
import { Form } from "react-bootstrap";

export const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <Form.Control
      type="text"
      placeholder="Search by name, username or email..."
      className="mb-3"
      value={value}
      onChange={e => setValue(e.target.value)}
    />
  );
};
